export default __webpack_public_path__ + "static/media/seller.0886e69a.svg";